//Error type
export const ERROR_EVENT_NOT_FOUND = "ERROR_EVENT_NOT_FOUND"
